<!-- Listado -->
<div class="card mb-2 wow">
  <div class="card-body">

    <form autocomplete="off" [formGroup]="formProductoLibre" novalidate>
      <div class="row" *ngIf="additionalHeaderInfo?.showProductoLibre">
        <!-- <div class="col" style="max-width: 150px;">
          <div class="md-form">
            <input value="" type="text" id="codProductLibre" class="form-control" placeholder="000" #codProductLibre
              formControlName="codigo" onlyNumbers />
            <label for="codProductLibre">Código de producto</label>
            <div *ngIf="
                formProductoLibre.get('codigo').invalid &&
                (formProductoLibre.get('codigo').dirty ||
                formProductoLibre.get('codigo').touched)
              ">
               <mdb-error *ngIf="formProductoLibre.get('codigo').hasError('required')">Ingrese código de
                producto
              </mdb-error>
              <mdb-error *ngIf="formProductoLibre.get('codigo').hasError('min')">Código no válido</mdb-error>
            </div>
          </div>
        </div> -->
        <div class="col" style="width: 400px;">
          <div class="md-form">
            <input value="" type="text" id="descripcionProductoLibre" class="form-control" placeholder="000" required
              #descripcionProductoLibre formControlName="descripcion" />
            <label for="descripcionProductoLibre">Descripción</label>
            <div *ngIf="
                formProductoLibre.get('descripcion').invalid &&
                (formProductoLibre.get('descripcion').dirty ||
                formProductoLibre.get('descripcion').touched)
              ">
              <mdb-error *ngIf="formProductoLibre.get('descripcion').hasError('required')">
                Ingrese descripción de producto
              </mdb-error>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="md-form" style="max-width: 200px;">
            <mdb-select [options]="optionsFormatoProductoLibre" [multiple]="false" [filterEnabled]="true"
              [highlightFirst]="false" placeholder="Seleccionar formato" formControlName="formato"></mdb-select>
            <label>Formato</label>
            <div *ngIf="
                formProductoLibre.get('formato').invalid &&
                (formProductoLibre.get('formato').dirty ||
                formProductoLibre.get('formato').touched)
              ">
              <mdb-error *ngIf="formProductoLibre.get('formato').hasError('required')">Ingrese formato
              </mdb-error>
            </div>
          </div>
        </div>
        <div class="col" style="max-width: 150px;">
          <div class="">
            <input value="" type="text" id="cant" class="form-control" placeholder="Ingrese cantidad" required #cant
              formControlName="cantidad" monto />
            <label for="cant">Cantidad</label>
            <div *ngIf="
                formProductoLibre.get('cantidad').invalid &&
                (formProductoLibre.get('cantidad').dirty ||
                formProductoLibre.get('cantidad').touched)
              ">
              <mdb-error *ngIf="formProductoLibre.get('cantidad').hasError('required')">Ingrese cantidad
              </mdb-error>
              <mdb-error *ngIf="formProductoLibre.get('cantidad').hasError('min')">Cantidad debe ser mayor a 0
              </mdb-error>
            </div>
          </div>
        </div>
        <div class="col" style="max-width: 150px;">
          <div class="md-form">
            <input value="" type="text" id="precioUnitario" class="form-control" placeholder="000" required
              #precioUnitario formControlName="precioUnitario" monto />
            <label for="precioUnitario">Precio unitario</label>
            <div *ngIf="
                formProductoLibre.get('precioUnitario').invalid &&
                (formProductoLibre.get('precioUnitario').dirty ||
                formProductoLibre.get('precioUnitario').touched)
              ">
              <mdb-error *ngIf="formProductoLibre.get('precioUnitario').hasError('required')">
                Ingrese precio unitario
              </mdb-error>
              <mdb-error *ngIf="formProductoLibre.get('precioUnitario').hasError('min')">
                Precio unitario debe ser mayor a 0
              </mdb-error>
            </div>
          </div>
        </div>

        <div class="col dato">

          <button mdbBtn type="button" size="sm" color="secondary" mdbWavesEffect (click)="AgregarCoreccionMonto()">
            Agregar Producto
          </button>

        </div>


      </div>
    </form>

    <div class="row" *ngIf="additionalHeaderInfo?.showProductoLibre">
      <div class="col">
        <div class="table-responsive">
          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col">

                </th>
                <th scope="col">Código</th>
                <th scope="col">Descripción</th>
                <th scope="col">Cantidad</th>
                <th scope="col">Formato</th>
                <th scope="col">Precio $</th>
                <th scope="col">Total $</th>
                <th></th>
              </tr>
            </thead>
            <tbody *ngIf="dataCabecera">
              <tr *ngFor="let detalle of  dataCabecera.detalleDocumento">
                <td>
                  <mdb-checkbox [checked]="detalle.additionalInfo?.checked"
                    (change)='checkDetalleProductoLibre(detalle)'></mdb-checkbox>
                </td>
                <td>{{ detalle.sku }}</td>
                <td>{{ detalle.descripcion_producto }}</td>
                <td>{{ detalle.cantidad }}</td>
                <td>{{ detalle.formato_nombre }}</td>
                <td>{{ detalle.precio_unitario | numerico }}</td>
                <td>{{ detalle.monto_total_neto | numerico }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <button type="button" mdbBtn color="warning" mdbWavesEffect size="sm" (click)="deleteDetallesCorrecionMonto()">
          Eliminar
        </button>
      </div>
    </div>

    <div class="row" *ngIf="additionalHeaderInfo?.showTabla">
      <div class="col">
        <div class="">
          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="grey lighten-2">
              <tr>
                <!-- <th scope="col">
                  <mdb-checkbox></mdb-checkbox>
                </th> -->
                <!-- <th></th> -->
                <th scope="col">
                  <span *ngIf="additionalHeaderInfo?.showMotivoEspecifico">código</span>
                  <span *ngIf="additionalHeaderInfo?.showSkuAnulacion">código</span>
                </th>
                <th scope="col">Descripción</th>
                <th scope="col" class="text-center">Cantidad</th>
                <th *ngIf="additionalHeaderInfo?.showMotivoEspecifico" scope="col">Devolver</th>
                <th scope="col">Formato</th>
                <!-- <th scope="col">Formato 2</th> -->
                <th scope="col" class="text-right">Precio $</th>
                <th scope="col" class="text-right">Desc. $</th>
                <th scope="col" class="text-right">Recargo $</th>
                <th scope="col" class="text-right">Total $</th>
                <th scope="col" *ngIf="additionalHeaderInfo?.showMotivoEspecifico">Motivo</th>
                <!-- <th *ngIf="!additionalHeaderInfo.denyEditMotivo && !additionalHeaderInfo.denyEditCantidad"></th> -->
              </tr>
            </thead>
            <tbody *ngIf="dataCabecera">
              <tr *ngFor="let detalle of dataCabecera.detalleDocumento">
                <td>
                  <span *ngIf="additionalHeaderInfo?.showMotivoEspecifico"><mdb-checkbox
                      [checked]="detalle.additionalInfo.checked" (change)='checkDetalle(detalle)'>{{ detalle.sku
                      }}</mdb-checkbox></span>
                  <span *ngIf="additionalHeaderInfo?.showSkuAnulacion">{{ detalle.sku }}</span>

                </td>

                <td>{{ detalle.descripcion_producto }}</td>
                <td class="text-center">{{ detalle.cantidad_original }}</td>
                <td style="max-width: 70px;" *ngIf="additionalHeaderInfo?.showMotivoEspecifico">
                  <div class="no-md-form">
                    <input value="" type="text" [id]="detalle.additionalInfo.id" class="form-control" required monto
                      min="1" [(ngModel)]="detalle.cantidad" name="cantidad" #cantidad="ngModel"
                      [readonly]="additionalHeaderInfo?.denyEditCantidad"
                      [disabled]="detalle.additionalInfo.checked == false"
                      (input)="devolucionChange(detalle, $event.target.value)" />
                    <mdb-error
                      *ngIf="!cantidad.valid && !additionalHeaderInfo?.denyEditCantidad">
                      Cantidad no válida
                    </mdb-error>
                    <!-- <mdb-error *ngIf="!cantidad.valid && !additionalHeaderInfo?.denyEditCantidad">
                      Ingrese cantidad
                    </mdb-error> -->
                  </div>
                </td>
                <td *ngIf="!additionalHeaderInfo?.showMotivoEspecifico">{{ detalle.formato_nombre }}</td>
                <td *ngIf="additionalHeaderInfo?.showMotivoEspecifico">
                  <mdb-select [options]="detalle.listaProductoFormato" placeholder="Seleccionar Formato"
                    [(ngModel)]="detalle.formato_codigo" name="formato_codigo"  #formato_codigo="ngModel" [readonly]="false" 
                    [disabled]="detalle.additionalInfo.checked == false"
                    [filterEnabled]="true" required (ngModelChange)="formatoChange(detalle)"></mdb-select>
                  <div *ngIf="!detalle.formato_codigo" style="color: #f44336;">Ingrese Formato</div>
                  <!-- <mdb-error *ngIf="!motivo_devolucion_especifico_codigo.valid">Ingrese motivo
                  </mdb-error> -->
                </td>
                <td class="text-right">{{ detalle.precio_unitario | numerico }}</td>
                <td class="text-right">{{ detalle.aplicacion_descuento | numerico }}</td>
                <td class="text-right">{{ detalle.aplicacion_recargo | numerico }}</td>
                <td class="text-right">{{ detalle.monto_total_neto | numerico }}</td>
                <td *ngIf="additionalHeaderInfo?.showMotivoEspecifico">
                  <mdb-select class="select-motivo" [options]="optionsMotivoEspecifico" placeholder="Seleccionar motivo"
                    [readonly]="additionalHeaderInfo?.denyEditMotivo"
                    [disabled]="detalle.additionalInfo.checked == false" [filterEnabled]="true" required
                    [(ngModel)]="detalle.motivo_devolucion_especifico_codigo" name="motivo_devolucion_especifico_codigo"
                    #motivo_devolucion_especifico_codigo="ngModel">
                    <!-- (ngModelChange)="motivoEspecificoChange(detalle, $event)" -->
                  </mdb-select>
                  <!-- && !motivo_devolucion_especifico_codigo.pristine -->
                  <div *ngIf="!motivo_devolucion_especifico_codigo.valid" style="color: #f44336;">
                    Ingrese motivo</div>
                  <!-- <mdb-error *ngIf="!motivo_devolucion_especifico_codigo.valid">Ingrese motivo
                  </mdb-error> -->
                </td>
                <!-- <td *ngIf="additionalHeaderInfo?.showMotivoEspecifico">
                  <button class="btn-sm" color="success" mdbBtn type="button" mdbWavesEffect
                    (click)="motivoEspecificoChange(detalle)">
                    Actualizar
                  </button>
                </td> -->
                <!-- <td *ngIf="!additionalHeaderInfo.denyEditMotivo && !additionalHeaderInfo.denyEditCantidad">
                  <button class="btn-sm" color="success" mdbBtn type="button" mdbWavesEffect
                    (click)="ValidarDetalle(detalle)">
                    Aceptar
                  </button>
                </td> -->
              </tr>

            </tbody>
          </table>
        </div>
        <!-- <button type="button" mdbBtn color="warning" mdbWavesEffect size="sm">
          Eliminar
        </button> -->
      </div>
    </div>

    <div class="row" *ngIf="additionalHeaderInfo?.showTotales && totales">
      <div class="col">
        <div class="table-responsive mt-1">
          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="blue lighten-5">
              <tr>
                <th scope="col">SubTotal</th>
                <th scope="col">Descto.</th>
                <th scope="col">Recargo</th>
                <th scope="col">Impto. Adic.</th>
                <th scope="col">Exento</th>
                <th scope="col">Neto</th>
                <th scope="col">IVA</th>
                <th scope="col">TOTAL</th>
              </tr>
            </thead>
            <tbody class="blue lighten-5">
              <tr>
                <td>{{ totales.subtotal | numerico }}</td>
                <td>{{ totales.descuento | numerico }}</td>
                <td>{{ totales.recargo | numerico }}</td>
                <td>
                  <span *ngIf="dataCabecera.cabecera.tipo_dte_codigo == 46">- {{ totales.iva | numerico }}</span>
                  <span *ngIf="dataCabecera.cabecera.tipo_dte_codigo != 46">{{ totales.impto_adic | numerico }}</span>
                </td>
                <td>{{ totales.exento | numerico }}</td>
                <td>{{ totales.neto | numerico }}</td>
                <td>{{ totales.iva | numerico }}</td>
                <td>
                  <strong *ngIf="dataCabecera.cabecera.tipo_dte_codigo == 46">{{ totales.subtotal | numerico }}</strong>
                  <strong *ngIf="dataCabecera.cabecera.tipo_dte_codigo != 46">{{ totales.total | numerico }}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <form autocomplete="off" [formGroup]="formGlosa" novalidate>
      <div class="row" *ngIf="additionalHeaderInfo?.showGlosa">
        <div class="col-4">
          <div class="md-form">
            <input value="" type="text" id="glosa" class="form-control" placeholder="glosa max. 80 caracteres" required
              #glosa maxlength="80" formControlName="glosa" />
            <label for="glosa">Glosa</label>
            <div *ngIf="
                formGlosa.get('glosa').invalid &&
                (formGlosa.get('glosa').dirty ||
                formGlosa.get('glosa').touched)
              ">
              <mdb-error
                *ngIf="formGlosa.get('glosa').hasError('required') && formGlosa.get('glosa').hasError('minLength')">
                Ingrese glosa
              </mdb-error>
              <mdb-error *ngIf="formGlosa.get('glosa').hasError('maxLength')">
                Máximo 300 caracteres
              </mdb-error>
            </div>
          </div>
        </div>
      </div>
    </form>

    <form autocomplete="off" [formGroup]="formMotivoGeneral" novalidate>
      <div class="row" *ngIf="additionalHeaderInfo?.showMotivoGeneral">
        <div class="col" style="max-width: 200px;">
          <mdb-select [options]="optionsMotivoGeneral" placeholder="Seleccionar motivo" [filterEnabled]="true"
            formControlName="motivo">
          </mdb-select>
        </div>
      </div>
    </form>

    <div class="row">
      <div class="col">
        <button size="sm" class="btn btn-sm" type="button" mdbBtn color="info" (click)="showModalObservaciones()"
          mdbWavesEffect>
          Observaciones
        </button>
      </div>
    </div>

  </div>
</div>

<app-modal-observaciones (onSelect)="saveObservaciones($event)"></app-modal-observaciones>